<div class="d-flex flex-column justify-content-center page-fullscreen">
  <div class="logo-goodwill d-flex justify-content-center pb-3">
    <img alt="goodwill-logo" src="assets/images/goodwill_GW-logo-black@2x.png">
  </div>
  <div class="d-flex flex-column align-items-center pt-3">
    <span class="text-uppercase font-weight-bold pb-3">{{'sso.authenticating' | translate}}</span>
    <span class="font-weight-600">{{'sso.automatic-redirection' | translate}}</span>
  </div>
</div>
